import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogPortal,
  DialogTitle,
} from '@/components/ui/dialog';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  question: string;
  confirmLabel: string;
  onConfirm: () => void;
};

export const InMeetingConfirmationDialog: FC<Props> = ({ open, onOpenChange, question, confirmLabel, onConfirm }) => {
  const { t } = useTranslation();
  const handleCancel = () => {
    onOpenChange(false);
  };

  const handleConfirm = () => {
    onConfirm();
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogPortal>
        <DialogContent className="max-w-[90%] sm:max-w-md mx-auto rounded-lg bg-white text-black px-6 pt-6 pb-4">
          <DialogHeader>
            <DialogTitle>{t('dialog.confirmation')}</DialogTitle>
            <DialogDescription />
          </DialogHeader>

          <div className="text-sm text-gray-900 pr-6">{question}</div>

          <DialogFooter className="flex justify-end gap-2 pt-6">
            <Button
              variant="ghost"
              className="px-4 py-1 h-auto text-indigo-700 hover:text-indigo-800 hover:bg-gray-100"
              onClick={handleCancel}
            >
              {t('dialog.cancel')}
            </Button>
            <Button
              variant="ghost"
              className="px-4 py-1 h-auto text-indigo-700 hover:text-indigo-800 hover:bg-gray-100"
              onClick={handleConfirm}
            >
              {confirmLabel}
            </Button>
          </DialogFooter>
        </DialogContent>
      </DialogPortal>
    </Dialog>
  );
};

export default InMeetingConfirmationDialog;
